export const queryKeys = {
  bin: ["bin"],
  banks: ["banks"],
  sales: ["sales"],
  materials: ["materials"],
  notifications: (filter) => ["notifications", filter || "all"],
  notificationCount: ["notifications", "count"],
};
